import {
  Box,
  Button,
  Center,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Select,
  Spacer,
  Spinner,
} from "@chakra-ui/react";
import useSuggestionForm from "../hooks/useSuggestionForm";
import SuggestedComic from "./SuggestedComic";
import SuggestedRowForm from "./SuggestedRowForm";
import SuggestionComicPreview from "./SuggestionComicPreview";
import SuggestedComics from "./SuggestedComics";

const SuggestionForm = () => {
  const {
    action,
    setAction,
    row,
    setRow,
    comic,
    setComic,
    story,
    setStory,
    isLoading,
    comicData,
    order,
    setOrder,
    onSubmit,
    suggestedAdditions,
    setSuggestedAdditions,
  } = useSuggestionForm();
  return (
    <Box>
      <form method="POST" action="#" onSubmit={(e) => onSubmit(e)}>
        <FormControl my="3">
          <Select value={action} onChange={(e) => setAction(e.target.value)}>
            <option value="add">Add new comic(s)</option>
            <option value="edit">Edit a comic/story</option>
            <option value="delete">Delete a comic</option>
          </Select>
        </FormControl>

        {action === "add" && (
          <>
            <Flex w="100%" gap={2}>
              <Box flex="1">
                <FormLabel>Add comic(s)</FormLabel>
                <Select
                  value={order}
                  onChange={(e) => setOrder(e.target.value)}
                >
                  <option value="after">After</option>
                  <option value="before">Before</option>
                </Select>
              </Box>
              <Box>
                <SuggestedRowForm
                  label={"Row"}
                  showBeforeAfter
                  order={order}
                  setOrder={setOrder}
                  row={row}
                  setRow={setRow}
                />
              </Box>
            </Flex>

            <Divider borderColor="gray.900" pt="3" pb="2" />

            {isLoading && (
              <Center>
                <Spinner />
              </Center>
            )}
            {!!comicData && order === "after" && (
              <>
                <SuggestionComicPreview comic={comicData} />
                <Divider borderColor="gray.900" py="2" />
              </>
            )}

            {!!row && (
              <SuggestedComics row={row} onChange={setSuggestedAdditions} />
            )}

            {!!comicData && order === "before" && (
              <>
                <Divider borderColor="gray.900" py="2" />
                {comicData && <SuggestionComicPreview comic={comicData} />}
              </>
            )}
          </>
        )}

        {action === "edit" && (
          <>
            <SuggestedRowForm
              label="Edit the comic/story at row"
              row={row}
              setRow={setRow}
            />
            {isLoading && (
              <Center>
                <Spinner />
              </Center>
            )}
            {!!row && (
              <SuggestedComic
                setComic={setComic}
                comic={comic}
                index={row}
                story={story}
                setStory={setStory}
              />
            )}
          </>
        )}

        {action === "delete" && (
          <>
            <SuggestedRowForm
              label="Delete the comic at row"
              row={row}
              setRow={setRow}
            />
            {!!comicData && (
              <>
                <Divider borderColor="gray.900" py="2" />
                <SuggestionComicPreview comic={comicData} isDeletion />
                <Divider borderColor="gray.900" py="2" />
              </>
            )}
          </>
        )}

        <HStack mt="9" gap={3}>
          <Spacer />
          <Button
            colorScheme="red"
            textColor="white"
            disabled={suggestedAdditions.map((x) => !!x.id).length === 0}
            type="submit"
          >
            Submit suggestion
          </Button>
        </HStack>
      </form>
    </Box>
  );
};

export default SuggestionForm;
